module.exports = __webpack_public_path__ + "static/img/yewuzhaodaifeiyong.7c688c23.png";